import React from "react";

const Amenities = () => {
  return (
    <div className="container mx-auto mt-16 mb-10 p-6">
      <div className="flex justify-center">
        <h1 className="text-3xl font-display font-semibold text-center">
          Orchid Nirvana 3.0 Amenities
        </h1>
      </div>
      <div className="flex flex-wrap justify-around mt-8">
        <div className="p-5 mt-3 w-64">
          <ul class="list list-disc">
            <li className="text-xl py-1">Clubhouse</li>
            <li className="text-xl py-1">Fruit Orchard</li>
            <li className="text-xl py-1">Jogging Track</li>
            <li className="text-xl py-1">Multi-purpose Hall</li>
            <li className="text-xl py-1">Outdoor Gym</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Amenities;
